module.exports = __webpack_public_path__ + "static/media/sad-face.fda37189.png";